/**
 * GENERATED by test/tools/manual-assets.mjs — do not edit by hand.
 *
 * Where each numbered marker sits on each manual screenshot, as a percentage of
 * the frame. Measured from the running app at capture time (see
 * test/tools/manual-capture.mjs), so re-capturing after a layout change moves
 * the markers with it instead of leaving them pointing at nothing.
 *
 * Captured: 2026-09-05T01:10:18.103Z
 */
export interface ManualHotspot {
  key: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface ManualShot {
  id: string;
  image: string;
  hotspots: ManualHotspot[];
}

export const MANUAL_SHOTS: ManualShot[] = [
  {
    "id": "getting-started.home",
    "image": "getting-started-home.webp",
    "hotspots": [
      {
        "key": "nav",
        "x": 52.05,
        "y": 3.56,
        "w": 34.04,
        "h": 8.11
      },
      {
        "key": "login",
        "x": 86.87,
        "y": 5.25,
        "w": 6.88,
        "h": 4.72
      },
      {
        "key": "cta",
        "x": 6.25,
        "y": 58.87,
        "w": 11.99,
        "h": 6.31
      }
    ]
  },
  {
    "id": "getting-started.signin",
    "image": "getting-started-signin.webp",
    "hotspots": [
      {
        "key": "email",
        "x": 46.28,
        "y": 21.68,
        "w": 46.67,
        "h": 7.65
      },
      {
        "key": "demo",
        "x": 46.28,
        "y": 76.92,
        "w": 22,
        "h": 7.3
      },
      {
        "key": "forgot",
        "x": 83.31,
        "y": 47.47,
        "w": 9.64,
        "h": 3.56
      },
      {
        "key": "register",
        "x": 72.8,
        "y": 88.4,
        "w": 7.56,
        "h": 2.67
      }
    ]
  },
  {
    "id": "getting-started.register",
    "image": "getting-started-register.webp",
    "hotspots": [
      {
        "key": "role",
        "x": 44.01,
        "y": 8.88,
        "w": 19.94,
        "h": 6.31
      }
    ]
  },
  {
    "id": "getting-started.signed-in",
    "image": "getting-started-signed-in.webp",
    "hotspots": [
      {
        "key": "avatar",
        "x": 90.97,
        "y": 5.39,
        "w": 2.78,
        "h": 4.44
      },
      {
        "key": "cart",
        "x": 86.37,
        "y": 5.39,
        "w": 2.78,
        "h": 4.44
      },
      {
        "key": "ribbon",
        "x": 0,
        "y": 0,
        "w": 100,
        "h": 4.2
      }
    ]
  },
  {
    "id": "courses.list",
    "image": "courses-list.webp",
    "hotspots": [
      {
        "key": "card",
        "x": 6.25,
        "y": 20.56,
        "w": 20.7,
        "h": 58.96
      }
    ]
  },
  {
    "id": "courses.detail",
    "image": "courses-detail.webp",
    "hotspots": [
      {
        "key": "title",
        "x": 75.2,
        "y": 38.3,
        "w": 16.4,
        "h": 2.25
      },
      {
        "key": "trial",
        "x": 75.2,
        "y": 56.62,
        "w": 16.4,
        "h": 5.12
      },
      {
        "key": "cart",
        "x": 75.2,
        "y": 49.84,
        "w": 16.4,
        "h": 5.12
      },
      {
        "key": "enroll",
        "x": 75.2,
        "y": 43.05,
        "w": 16.4,
        "h": 5.12
      }
    ]
  },
  {
    "id": "purchase.cart",
    "image": "purchase-cart.webp",
    "hotspots": [
      {
        "key": "notice",
        "x": 60.49,
        "y": 9.14,
        "w": 37.36,
        "h": 5.39
      },
      {
        "key": "pay",
        "x": 79.95,
        "y": 91.08,
        "w": 17.9,
        "h": 5.47
      },
      {
        "key": "items",
        "x": 58.33,
        "y": 0,
        "w": 41.67,
        "h": 100
      }
    ]
  },
  {
    "id": "purchase.orders",
    "image": "purchase-orders.webp",
    "hotspots": [
      {
        "key": "table",
        "x": 6.25,
        "y": 23.51,
        "w": 87.5,
        "h": 37.03
      },
      {
        "key": "row",
        "x": 7.88,
        "y": 32.12,
        "w": 84.24,
        "h": 6.64
      }
    ]
  },
  {
    "id": "purchase.order-detail",
    "image": "purchase-order-detail.webp",
    "hotspots": [
      {
        "key": "detail",
        "x": 6.25,
        "y": 23.51,
        "w": 87.5,
        "h": 37.03
      }
    ]
  },
  {
    "id": "online-class.dashboard",
    "image": "online-class-dashboard.webp",
    "hotspots": [
      {
        "key": "heading",
        "x": 6.25,
        "y": 22.41,
        "w": 87.5,
        "h": 3.94
      },
      {
        "key": "card",
        "x": 5.47,
        "y": 28.02,
        "w": 22.27,
        "h": 49.59
      },
      {
        "key": "enter",
        "x": 6.32,
        "y": 28.13,
        "w": 20.56,
        "h": 49.36
      }
    ]
  },
  {
    "id": "online-class.start-dialog",
    "image": "online-class-start-dialog.webp",
    "hotspots": [
      {
        "key": "enter",
        "x": 38.51,
        "y": 86.35,
        "w": 22.97,
        "h": 7.33
      },
      {
        "key": "pause",
        "x": 37.59,
        "y": 59.06,
        "w": 24.81,
        "h": 6.32
      }
    ]
  },
  {
    "id": "online-class.watch",
    "image": "online-class-watch.webp",
    "hotspots": [
      {
        "key": "player",
        "x": 6.25,
        "y": 38.32,
        "w": 57.9,
        "h": 52.11
      },
      {
        "key": "chapters",
        "x": 65.52,
        "y": 38.43,
        "w": 28.16,
        "h": 33.25
      },
      {
        "key": "tabs",
        "x": 8.4,
        "y": 92.62,
        "w": 17.64,
        "h": 7.67
      }
    ]
  },
  {
    "id": "online-class.lesson-quizzes",
    "image": "online-class-lesson-quizzes.webp",
    "hotspots": [
      {
        "key": "quizzes",
        "x": 8.4,
        "y": 40.76,
        "w": 83.19,
        "h": 18.58
      }
    ]
  },
  {
    "id": "quiz.list",
    "image": "quiz-list.webp",
    "hotspots": [
      {
        "key": "list",
        "x": 6.38,
        "y": 12.02,
        "w": 87.24,
        "h": 74.45
      },
      {
        "key": "start",
        "x": 9.18,
        "y": 40.33,
        "w": 23.47,
        "h": 5.47
      },
      {
        "key": "best",
        "x": 9.18,
        "y": 31.66,
        "w": 23.47,
        "h": 6.67
      }
    ]
  },
  {
    "id": "quiz.drills",
    "image": "quiz-drills.webp",
    "hotspots": [
      {
        "key": "drills",
        "x": 6.38,
        "y": 38.68,
        "w": 87.24,
        "h": 22.54
      }
    ]
  },
  {
    "id": "quiz.question",
    "image": "quiz-question.webp",
    "hotspots": [
      {
        "key": "index",
        "x": 61.66,
        "y": 12.51,
        "w": 3.18,
        "h": 3.56
      },
      {
        "key": "body",
        "x": 9.88,
        "y": 39.89,
        "w": 53.85,
        "h": 3.7
      },
      {
        "key": "choice",
        "x": 9.88,
        "y": 46.48,
        "w": 53.85,
        "h": 7.11
      },
      {
        "key": "advance",
        "x": 17.79,
        "y": 82.03,
        "w": 45.95,
        "h": 5.47
      }
    ]
  },
  {
    "id": "quiz.review",
    "image": "quiz-review.webp",
    "hotspots": [
      {
        "key": "heading",
        "x": 9.88,
        "y": 36.14,
        "w": 53.85,
        "h": 3.38
      },
      {
        "key": "submit",
        "x": 17.79,
        "y": 58.45,
        "w": 45.95,
        "h": 5.47
      },
      {
        "key": "unanswered",
        "x": 9.88,
        "y": 41.52,
        "w": 53.85,
        "h": 6.05
      }
    ]
  },
  {
    "id": "quiz.result",
    "image": "quiz-result.webp",
    "hotspots": [
      {
        "key": "score",
        "x": 8.98,
        "y": 34.81,
        "w": 9.24,
        "h": 7
      },
      {
        "key": "difficulty",
        "x": 9.32,
        "y": 58.22,
        "w": 54.97,
        "h": 7
      }
    ]
  },
  {
    "id": "quiz.breakdown",
    "image": "quiz-breakdown.webp",
    "hotspots": [
      {
        "key": "skills",
        "x": 9.32,
        "y": 46.48,
        "w": 54.97,
        "h": 7
      }
    ]
  },
  {
    "id": "quiz.answer-key",
    "image": "quiz-answer-key.webp",
    "hotspots": [
      {
        "key": "answers",
        "x": 9.32,
        "y": 48.7,
        "w": 54.97,
        "h": 2.59
      }
    ]
  },
  {
    "id": "skills.overview",
    "image": "skills-overview.webp",
    "hotspots": [
      {
        "key": "heading",
        "x": 6.25,
        "y": 12.01,
        "w": 87.5,
        "h": 3.04
      },
      {
        "key": "narrative",
        "x": 6.25,
        "y": 17.13,
        "w": 87.5,
        "h": 32.85
      }
    ]
  },
  {
    "id": "skills.weak-topics",
    "image": "skills-weak-topics.webp",
    "hotspots": [
      {
        "key": "topic",
        "x": 85.41,
        "y": 12.05,
        "w": 6.18,
        "h": 4.72
      },
      {
        "key": "misconceptions",
        "x": 6.32,
        "y": 74.71,
        "w": 87.36,
        "h": 49.9
      }
    ]
  },
  {
    "id": "skills.next-steps",
    "image": "skills-next-steps.webp",
    "hotspots": [
      {
        "key": "recommendations",
        "x": 6.32,
        "y": 12.02,
        "w": 87.36,
        "h": 56.85
      }
    ]
  },
  {
    "id": "profile.study-record",
    "image": "profile-study-record.webp",
    "hotspots": [
      {
        "key": "heading",
        "x": 33.06,
        "y": 21.02,
        "w": 58.54,
        "h": 3.04
      },
      {
        "key": "chart",
        "x": 33.06,
        "y": 33.8,
        "w": 58.54,
        "h": 37.22
      },
      {
        "key": "activity",
        "x": 33.06,
        "y": 79.17,
        "w": 58.54,
        "h": 60.55
      },
      {
        "key": "tabs",
        "x": 40.01,
        "y": 12.01,
        "w": 10.75,
        "h": 5.67
      }
    ]
  },
  {
    "id": "profile.quiz-record",
    "image": "profile-quiz-record.webp",
    "hotspots": [
      {
        "key": "record",
        "x": 33.06,
        "y": 19.35,
        "w": 58.54,
        "h": 236.2
      },
      {
        "key": "tabskills",
        "x": 53.36,
        "y": 12.01,
        "w": 5.72,
        "h": 5.67
      }
    ]
  },
  {
    "id": "profile.account",
    "image": "profile-account.webp",
    "hotspots": [
      {
        "key": "save",
        "x": 79.84,
        "y": 19.19,
        "w": 11.76,
        "h": 4.72
      }
    ]
  },
  {
    "id": "profile.parent",
    "image": "profile-parent.webp",
    "hotspots": [
      {
        "key": "add",
        "x": 33.06,
        "y": 36.84,
        "w": 54.83,
        "h": 5.74
      },
      {
        "key": "code",
        "x": 33.06,
        "y": 36.84,
        "w": 54.83,
        "h": 5.74
      }
    ]
  },
  {
    "id": "profile.password",
    "image": "profile-password.webp",
    "hotspots": [
      {
        "key": "save",
        "x": 79.84,
        "y": 19.19,
        "w": 11.76,
        "h": 4.72
      }
    ]
  },
  {
    "id": "blog.list",
    "image": "blog-list.webp",
    "hotspots": [
      {
        "key": "row",
        "x": 29.89,
        "y": 35.61,
        "w": 15.62,
        "h": 39.46
      },
      {
        "key": "search",
        "x": 6.25,
        "y": 24.95,
        "w": 20.7,
        "h": 44.09
      }
    ]
  },
  {
    "id": "blog.detail",
    "image": "blog-detail.webp",
    "hotspots": [
      {
        "key": "article",
        "x": 6.25,
        "y": 26.79,
        "w": 65.23,
        "h": 63.02
      }
    ]
  }
];

export const MANUAL_SHOT_MAP: Record<string, ManualShot> = MANUAL_SHOTS.reduce(
  (acc, shot) => ({ ...acc, [shot.id]: shot }),
  {} as Record<string, ManualShot>
);
